// src/hooks/sale/useQuotationPermissions.ts

import { useMemo } from 'react';
import { useSelector } from 'react-redux';

import { getQuotationPermissions } from '../../features/quotation/quotationPermissions';
import { useAuthUser } from '../auth/useAuthUser';
import { RootState } from '../../store/store';

/**
 * Permisos de Cotizaciones, derivados del set de permisos del JWT
 * (`state.auth.permissions`). El rol solo se usa para el break-glass de SUPPORT.
 */
export const useQuotationPermissions = () => {
  const { hasRole } = useAuthUser();
  const granted = useSelector((state: RootState) => state.auth.permissions || []);

  return useMemo(() => {
    const set = new Set(granted);
    return getQuotationPermissions(hasRole, (permission) => set.has(permission));
  }, [granted, hasRole]);
};
